module.exports = __webpack_public_path__ + "static/media/PPI Leeds.384436eb.png";